<template>
	<main>
		<div class="row" style="margin: auto 0px; min-height: 100%;">

			<DesktopMenu />

			<div class="col col-md-10 margin-0">

				<MobileMenu />

				<div style="padding: 0px 30px; min-height: 720px;" class="lists"> 
					<a class="hide-on-mobile custom mt-4 text-right c-grey f-14" href="javascript:;" @click="logout">Keluar</a>
					<hr class="mb-4 hide-on-mobile">
					<vue-page-transition name="fade-in-left">
						<router-view/>
					</vue-page-transition>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import DesktopMenu from '@/layouts/components/DesktopMenu'
import MobileMenu from '@/layouts/components/MobileMenu'

export default {
	name: 'Main',
	components: {
		DesktopMenu,
		MobileMenu
	},
	methods: {
		logout() {
			let _ = this
			_.$store.dispatch('logout')
			_.$router.push('/')
		}
	}
}
</script>